import axios from "axios";
import isEmpty from "is-empty";

type GetSuggestionsParams = {
    query: string;
    searchType: string;
    page: number;
    perPage: number;
    filterParams: Record<string, unknown>;
    staticFilterParams: Record<string, unknown>;
    sort: string;
};

export const searchApi = {
    async getSuggestions(
        {
            query,
            searchType,
            page,
            perPage,
            filterParams,
            staticFilterParams,
            sort,
        }: GetSuggestionsParams
    ) {
        const response = await axios.post("/search", {
            queryString: query,
            searchType,
            page,
            perPage,
            filterParams: !isEmpty(filterParams)
                ? filterParams
                : staticFilterParams,
            sort,
        });

        return response.data?.success?.data?.searchSuggestions ?? [];
    },
};
